import { forwardRef } from "react";

import { useHistory } from "react-router-dom";

import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import { CMP_LEARNING_HUB_EVENT_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import classes from "./EventCard.module.css";
import formatEventDashboardDateTime from "./formatEventDashboardDateTime";

const EventDashboardCarouselCard = forwardRef(
  ({ slug, imageUrl, title, startTime, location, shortDescription, registerNowUrl }, ref) => {
    const history = useHistory();
    const { resolvedUrls } = useCmpRelatedUrl();

    const eventPath = resolvedUrls[CMP_LEARNING_HUB_EVENT_URL].replace(":slug", slug);

    const stopCardNavigation = event => {
      event.stopPropagation();
    };

    const registerButton = registerNowUrl ? (
      <ButtonV2
        color="dark"
        size="xs"
        as={ExternalTextLink}
        href={registerNowUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline={false}
        onClick={stopCardNavigation}
        sx={{
          px: 20,
          fontSize: 12,
          alignSelf: "flex-start"
        }}
      >
        register
      </ButtonV2>
    ) : (
      <ButtonV2
        color="dark"
        size="xs"
        sx={{
          px: 20,
          fontSize: 12,
          alignSelf: "flex-start"
        }}
        onClick={event => {
          stopCardNavigation(event);
          history.push(eventPath);
        }}
      >
        register
      </ButtonV2>
    );

    return (
      <Stack
        ref={ref}
        bg="white"
        borderRadius={20}
        gap={0}
        height={imageUrl ? "100%" : undefined}
        overflow="hidden"
        style={{ cursor: "pointer" }}
        onClick={() => history.push(eventPath)}
      >
        {imageUrl && (
          <Box
            minHeight={200}
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover"
            }}
          />
        )}
        <Stack gap={16} padding={[24, 24, 28]} flexGrow={1} minHeight={0}>
          <Stack gap={12} flexGrow={1} minHeight={0}>
            <Box fontFamily="gilroyBold" fontSize={[18, 18, 24]} lineHeight="120%">
              {title}
            </Box>
            <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]} lineHeight="140%" color="#5220DD">
              {formatEventDashboardDateTime(startTime)}
            </Box>
            <Box
              fontFamily="gilroyMedium"
              fontSize={[14, 14, 16]}
              lineHeight="140%"
              color="#5220DD"
            >
              {location}
            </Box>
            {shortDescription ? (
              <Box
                flexGrow={1}
                minHeight={0}
                className={classes.truncateText}
                fontFamily="gilroyMedium"
                fontSize={[14, 14, 14]}
                lineHeight="140%"
              >
                {shortDescription}
              </Box>
            ) : null}
          </Stack>
          <Box mt="auto" onClick={stopCardNavigation}>
            {registerButton}
          </Box>
        </Stack>
      </Stack>
    );
  }
);

export default EventDashboardCarouselCard;
